import { render, staticRenderFns } from "./productCarousel.vue?vue&type=template&id=4c7ff660&"
import script from "./productCarousel.vue?vue&type=script&lang=js&"
export * from "./productCarousel.vue?vue&type=script&lang=js&"
import style0 from "./productCarousel.vue?vue&type=style&index=0&id=4c7ff660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports